import { loginAsync, LOGIN_CHANGE } from 'actions';
import { Cognito } from '@xbcb/aws-utils';

export default async ({ dispatch, location, history, remember, userToken }) => {
  const cognitoAttributes = await Cognito.getUserAttributes();
  const success = await dispatch(
    loginAsync({ ...cognitoAttributes, userToken }),
  );
  if (success) {
    if (remember) {
      await Cognito.setDeviceStatusRemembered();
    } else {
      await Cognito.setDeviceStatusNotRemembered();
    }
    const newPath = !location.search.startsWith('?redirect=')
      ? '/'
      : location.search.split('=')[1];
    history.push(newPath);
    dispatch(LOGIN_CHANGE({ isLoading: false }));
  } else {
    throw new Error('An error occurred while logging in.');
  }
};
